import { render, staticRenderFns } from "./firefox.vue?vue&type=template&id=63a9a22e&lang=html&"
import script from "./firefox.vue?vue&type=script&lang=js&"
export * from "./firefox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "firefox.vue"
export default component.exports